import { FC, useCallback, useEffect, useState } from 'react';
import { Dropdown, Space } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

import MeetingAction from '../MeetingAction';
import { getDevices } from '../_utils';

interface IProps {
  isVideoEnabled: boolean;
  isAudioEnabled: boolean;
}

const AudioRouteButton: FC<IProps> = () => {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedId] = useState<string | undefined>();

  const checkSelectedDevice = useCallback(() => {
    // TODO: removed to implement with twilio
  }, []);

  const getMicrophoneDevices = useCallback(() => {
    (async () => {
      try {
        const data = await getDevices();

        if (!data?.microphones) {
          throw new Error();
        }

        checkSelectedDevice();
        setDevices(data.microphones);
      } catch {
        setDevices([]);
      }
    })();
  }, [checkSelectedDevice]);

  useEffect(() => {
    getMicrophoneDevices();

    navigator.mediaDevices.addEventListener(
      'devicechange',
      getMicrophoneDevices
    );

    return () => {
      navigator.mediaDevices.removeEventListener(
        'devicechange',
        getMicrophoneDevices
      );
    };
  }, [getMicrophoneDevices]);

  const onSwitchMicrophone = async (device: MediaDeviceInfo) => {
    // TODO: removed to implement with twilio
    console.log('device', device);
  };

  return (
    <Dropdown
      menu={{
        items: devices.map(item => ({
          key: item.deviceId,
          label: (
            <Space align="center" size={6}>
              {selectedId === item.deviceId ? (
                <CheckOutlined style={{ fontSize: 12, color: '#18212C' }} />
              ) : (
                <div style={{ width: 12 }} />
              )}
              {item.label}
            </Space>
          ),
          onClick() {
            onSwitchMicrophone(item);
          }
        }))
      }}
      placement="topRight"
      trigger={['click']}
    >
      <MeetingAction icon="speaker" />
    </Dropdown>
  );
};

export default AudioRouteButton;
